import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsLeadershipManagementEnabled = () => boolean;
export const useIsLeadershipManagementEnabled: UseIsLeadershipManagementEnabled = () => {
  const isVivaEngagePremiumTreatmentEnabled =
    useExperimentTreatmentWithoutReporting(Experiment.VivaEngagePremium) === true;

  return isVivaEngagePremiumTreatmentEnabled;
};
